import {FacePart} from "../../common";

export default new FacePart({
	defs: [

	],
	render () {
		return `
			<g transform="translate(2.000000, 52.000000)" fill="#000000" fill-opacity="0.699999988">
				<rect x="42" y="18" width="24" height="6" rx="3"/>
			</g>
		`;
	},
});



// WEBPACK FOOTER //
// ./src/face/mouth/serious.js